import { Application } from "stimulus";
import FromSessionstoreController from "./controllers/from_sessionstore_controller";
import InputValidationController from "./controllers/input_validation_controller";
import SlugifyController from "./controllers/slugify_controller";
import TextSelectController from "./controllers/text_select_controller";
import TimezoneDetectorController from "./controllers/timezone_detector_controller";
import ToSessionstoreController from "./controllers/to_sessionstore_controller";

require("./intercom");
require("./tabtastic");

const application = Application.start();
application.handleError = (error, message, detail) => {
  // tslint:disable-next-line:no-console
  console.error(message, detail);
  Raven.captureException(error);
};

application.register("from-sessionstore", FromSessionstoreController);
application.register("input-validation", InputValidationController);
application.register("slugify", SlugifyController);
application.register("text-select", TextSelectController);
application.register("timezone-detector", TimezoneDetectorController);
application.register("to-sessionstore", ToSessionstoreController);
